import { tvpil } from '../compat/tvpil';

import { composeChannels } from './composeChannels';
import { getChannelsPersonalization } from './personalization/getChannelsPersonalization';
import { getChannelAssetsQueryData, getChannelCollectionQueryData, getEntitledChannelsQueryData } from './queryData';
import { getChannelsSettings } from './settings';

export type GetChannelsArgs = {
  referenceId: string;
  pageReferenceId?: string;
};

export function getChannels({ referenceId, pageReferenceId }: GetChannelsArgs) {
  const channelAssetsData = getChannelAssetsQueryData();
  const entitledChannelsData = getEntitledChannelsQueryData();
  const channelCollectionData = getChannelCollectionQueryData(referenceId);
  const channelsPersonalization = getChannelsPersonalization({ referenceId, pageReferenceId });

  const category = tvpil.categoryTreeItemsMap.get(referenceId);

  if (!category) {
    return undefined;
  }

  const settings = getChannelsSettings(category);

  if (!settings) {
    return undefined;
  }

  if (!channelAssetsData || !entitledChannelsData || !channelCollectionData || !channelsPersonalization) {
    return undefined;
  }

  const channels = composeChannels({
    channelAssetsMap: channelAssetsData.channelMap,
    channelCollection: channelCollectionData.collection,
    entitledChannels: entitledChannelsData,
    personalization: channelsPersonalization,
    settings,
  });

  if (settings.limit) {
    return channels.slice(0, settings.limit);
  }

  return channels;
}
